import React from "react";
import { useSelector } from "react-redux";

import { showBomUsageLimitSelector } from "../../../../features/ui/mainLayoutSlice";
import BOMUsage from "../../../BOMUsage/BOMUsage";

function HeaderItems() {
  const showUsageLimit = useSelector(showBomUsageLimitSelector);

  if (!showUsageLimit) {
    return null;
  }

  return (
    <div className="d-flex gap-4 justify-content-between align-items-center">
      <BOMUsage />
      <a href={`${process.env.REACT_APP_MAIN_SITE_URL}/dashboard/upgrade/products/usmca`} className="btn btn-outline-primary fw-bold">
        Buy More
      </a>
    </div>
  );
}

export default HeaderItems;
